var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Collapsible_1;
import { defaultOptions } from '@slickdeals/durango/dist/javascript/decorators/defaultOptions';
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import { observable } from '@slickdeals/durango/dist/javascript/decorators/observable';
import TargetStrategy from '@slickdeals/durango/dist/javascript/strategies/visibility/targetStrategy';
import TriggerStrategy from '@slickdeals/durango/dist/javascript/strategies/visibility/triggerStrategy';
import BlueprintComponent from '../core/blueprintComponent';
import IconStrategy from '../strategies/indicator/iconStrategy';
import VisibilityToggle, { ObservableEvents as VisibilityToggleObserverableEvents, ClassNames as VisibilityToggleClassNames } from './visibilityToggle';
import './button';
import './icon';
import '../../scss/components/collapsible.scss';
/** The name of the module */
export const name = 'Collapsible';
/** Class names for this module */
export var ClassNames;
(function (ClassNames) {
    ClassNames["Default"] = "bp-c-collapsible";
    ClassNames["JavaScript"] = "js-collapsible";
    ClassNames["Trigger"] = "js-collapsible_trigger";
    ClassNames["Target"] = "js-collapsible_target";
})(ClassNames || (ClassNames = {}));
export var ObservableEvents;
(function (ObservableEvents) {
    ObservableEvents["Toggled"] = "collapsibleToggled";
})(ObservableEvents || (ObservableEvents = {}));
let Collapsible = Collapsible_1 = class Collapsible extends BlueprintComponent {
    /**
       * Create a Collapsible UI component
       *
       * @param options Data and options to initialize the component with
       */
    constructor(options = {}) {
        super(name, options);
        /** Determines if the collapsible will default in an expanded state */
        this.expanded = false;
        this.expanded = this.options.expanded;
        this.indicatorStrategy = this.options.indicatorStrategy;
    }
    /**
       * Create a new instance of this object
       *
       * @param options Data and options to initialize component with
       */
    static create(options) {
        return new Collapsible_1(options);
    }
    /**
     * Performs any necessary initialization for the component
     */
    async init() {
        super.init();
        this.element = await BlueprintComponent.loadElement(name, this.options);
        // Load the trigger element
        if (this.options.triggerElement) {
            this.triggerElement = this.options.triggerElement;
        }
        else {
            this.triggerElement = this.element.querySelector(`.${ClassNames.Trigger}`);
        }
        // Load the target element
        if (this.options.targetElement) {
            this.targetElement = this.options.targetElement;
        }
        else {
            this.targetElement = this.element.querySelector(`.${ClassNames.Target}`);
        }
        this.initVisibilityToggle();
    }
    /**
     * Perform any required cleanup to properly destroy the component
     */
    destroy() {
        super.destroy();
        this.visibilityToggle.destroy();
    }
    /** Initialize visibility toggle and all of its required parameters */
    initVisibilityToggle() {
        const triggerStrategy = new TriggerStrategy({
            classNames: {
                base: VisibilityToggleClassNames.Default,
                visible: VisibilityToggleClassNames.Visible,
            },
            element: this.triggerElement,
        });
        const targetStrategy = new TargetStrategy({
            elements: this.targetElement,
            defaultVisibility: this.expanded,
            classNames: {
                base: VisibilityToggleClassNames.Default,
                visible: VisibilityToggleClassNames.Visible,
            },
        });
        const { indicatorStrategy } = this;
        this.visibilityToggle = new VisibilityToggle({
            triggerStrategy,
            targetStrategy,
            indicatorStrategy,
        });
        /**
         * Subscribes to the observable on visibilityToggle.
         * Takes in visibilityData of both the trigger and target and dispatches it's own collapsible
         * event so that modules can tap directly into when a collapsible's visibility changes
         */
        this.visibilityToggle.subscribe((visibilityData) => {
            this.notify(visibilityData, ObservableEvents.Toggled);
        }, VisibilityToggleObserverableEvents.Toggled);
    }
};
Collapsible = Collapsible_1 = __decorate([
    injectable(name),
    observable,
    defaultOptions({
        indicatorStrategy: IconStrategy,
        expanded: false,
    })
], Collapsible);
export default Collapsible;
// Create collapsible components in the hydration queue
BlueprintComponent.instantiate(name);
